// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".stopCadenceModal-module__text___uDvEs {\n  margin-bottom: 30px;\n  text-align: center;\n}\n", "",{"version":3,"sources":["webpack://./src/js/components/stopCadenceModal/stopCadenceModal.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,kBAAkB;AACpB","sourcesContent":[".text {\n  margin-bottom: 30px;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"text": "stopCadenceModal-module__text___uDvEs"
};
export default ___CSS_LOADER_EXPORT___;
